import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { AppComponent } from '../app.component';
import { AuthService } from '../_services/auth.service';
import { ToastrService } from '../_services/toastr.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.css']
})
export class TwoFactorAuthenticationComponent implements OnInit {
  model: any = {};
  tfaForm: FormGroup;
  appName: any;
  copyright: any;

  // tslint:disable-next-line: max-line-length
  constructor(private authService: AuthService, private fb: FormBuilder, private toastrService: ToastrService, private appComponent: AppComponent, private router: Router) { }

  ngOnInit() {
    const is2faenabled = JSON.parse(localStorage.getItem('is2faenabled'));
    if (is2faenabled) {
      this.CreateTFAForm();
      this.appComponent.setTitle('2-step verification');
      const body = document.getElementsByTagName('body')[0];
      body.classList.add('login-page');
      this.appName = environment.projectName;
      this.copyright = environment.copyright;
    } else {
      this.router.navigate(['/login']);
    }
  }

  CreateTFAForm() {
    const id = localStorage.getItem('uid');
    this.tfaForm = this.fb.group({
      TFACode: ['', [Validators.required]],
      Id: [id, [Validators.required]]
    });
  }

  LoginByTFA() {
    if (this.tfaForm.valid) {
      this.model = Object.assign({}, this.tfaForm.value);
      this.model.Id = localStorage.getItem('uid');
      this.authService.loginByTFA(this.model).subscribe(data => {

        },
        (error) => {
          Swal.fire({
            title: 'ERROR',
            text: error,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
          });
          console.log(error);
        },
        () => {
          window.location.href = localStorage.getItem('index');
        }
      );
    } else {
      this.appComponent.validateAllFormFields(this.tfaForm);
    }
  }

}
